<template>
  <div id="blogSettings">
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="configForm">
      <v-layout wrap class="pr-4 pl-4 flex-column">
        <v-flex class="xs12 sm6">
          <v-text-field label="Content Word Count" v-model="blogSettings.word_count" class="required" :class="{'pr-4': $vuetify.breakpoint.smAndUp}" @input="changedData" type="number"></v-text-field>
        </v-flex>
        <v-flex class="xs12 sm6" v-if="Agency.is_super_admin">
          <v-combobox v-model="blogSettings.tags" :items="blogSettings.tags" label="Blog tags - hit enter to add new" multiple deletable-chips small-chips @change="changedData"></v-combobox>
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* global session store  */
import swal from 'sweetalert2';
// import { mapGetters } from 'vuex';
import { getCollection, update } from '../../helpers/helpers';

export default {
  name: 'family_menu',
  // components: {
  // },
  data: () => ({
    blogSettings: {
      word_count: 1500,
      tags: []
    },
    selectedData: false,
    settingsBackup: null
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Blogs');

    /* Fetch the admin menu settings */
    await this.fetchAdminBlogSettings();

    /* The word count should be of agency if exists */
    if (this.Agency && this.Agency.blog_settings && typeof this.Agency.blog_settings.word_count !== 'undefined') {
      this.blogSettings.word_count = this.Agency.blog_settings.word_count;
    }

    this.settingsBackup = JSON.parse(JSON.stringify(this.blogSettings));
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    reset () {
      this.blogSettings = JSON.parse(JSON.stringify(this.settingsBackup));
      this.hideButtons();
    },
    async fetchAdminBlogSettings () {
      if (!this.Agency.is_super_admin) {
        let { error, data, status } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'blog_settings');
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the admin settings'
          };
        } else {
          data = data && data.length ? data[0] : null;
          if (data && data.blog_settings && Object.keys(data.blog_settings).length) {
            this.blogSettings = data.blog_settings;
          }
        }
      } else {
        this.blogSettings = this.Agency.blog_settings ? this.Agency.blog_settings : this.blogSettings;
      }
    },
    async save () {
      this.selectedData = false;
      let updatePayload = JSON.parse(JSON.stringify(this.Agency));
      if (Object.keys(this.blogSettings).length) {
        if (typeof this.blogSettings.word_count !== 'undefined') {
          this.blogSettings.word_count = parseInt(this.blogSettings.word_count, 10);
        }
        updatePayload.blog_settings = this.blogSettings;
        updatePayload.updated_from = 'basic'; // basic will just update the data, wont process the related jobs
        
        let { error, data, status } = await update('Agency', updatePayload, updatePayload.id);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update the data'
          };
        } else {
          /* Update the state */
          this.Agency.blog_settings = this.blogSettings;
          swal.fire({
            type: 'success',
            title: 'Blog settings updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.hideButtons();
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Settings/blogs.vue